// Ordering of the @ menu, kept pure so it can be tested without a DOM.
//
// The menu holds a handful of rows and the candidate kinds are concatenated
// in a fixed order (users, agents, skills, tools, apps, workflows,
// collections, context blocks). Cutting that list at N used to mean that with
// an empty query ("@" alone) the rows were all users and agents, and the
// kinds at the tail — Context above all — never appeared, so nobody knew
// they could be mentioned.
//
// `rankMentionCandidates` deals the rows out in rounds instead: one from each
// kind, then a second from each, until the limit — every kind that has
// something to show is visible from the first keystroke, and each kind keeps
// its own internal order (relevance for a typed query).

export function rankMentionCandidates(groups, limit = 12) {
  const queues = (groups || []).map(g => (Array.isArray(g) ? [...g] : []))
  const out = []

  while (out.length < limit && queues.some(q => q.length > 0)) {
    for (const q of queues) {
      if (out.length >= limit) break
      if (q.length > 0) out.push(q.shift())
    }
  }

  return out
}
